import { fetchJson } from "#/utils/fetch";
import { Logger } from "#/lib/logging";
import { BrowserResultBody } from "#/lib/command-types/command-result";
import { hashData } from "#/utils/general";
import { getApiUrl } from "#/constants/environment";

export const sendBrowserResultAction = async (
  apiToken: string,
  body: BrowserResultBody,
  headers: Record<string, string> = {}
): Promise<void> => {

  const serializedBody = JSON.stringify(body);

  // Create HMAC signature using the API token
  const signature = hashData(serializedBody, apiToken);

  // Send the request to the MCP API endpoint
  const {
    failure
  } = await fetchJson(`${getApiUrl()}/api/browser-result`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Signature": signature,
      ...headers
    },
    body: serializedBody
  });
  if (failure) {
    throw Logger.error({
      message: "Failed to send browser result",
      error: failure.error,
      metadata: failure.metadata
    });
  }
};
